/**
 * Ubicación DIVIPOLA (DANE) en cascada: departamento y luego solo sus municipios. Hay ciudades con el mismo nombre en
 * departamentos distintos; se guardan los dos códigos.
 */
import { useMemo } from 'react';
import { DIVIPOLA_DEPARTMENTS, municipalitiesOfDepartment } from '@pqrs/contracts';
import { SelectorBuscable } from '@xiltrion/ui/bloques/selectores';
import { Field } from '@/components/ui';

export interface Place { departmentCode: string | null; municipalityCode: string | null }

export function PlaceSelect({ departmentCode, municipalityCode, onChange, idPrefix = 'place', hint, disabled, required, errors }: Place & { onChange: (p: Place) => void; idPrefix?: string; hint?: string; disabled?: boolean; required?: boolean; errors?: { department?: string; municipality?: string } }) {
  const departments = useMemo(() => DIVIPOLA_DEPARTMENTS.map((d) => ({ value: d.code, label: d.name })), []);
  const municipalities = useMemo(() => municipalitiesOfDepartment(departmentCode).map((m) => ({ value: m.code, label: m.name })), [departmentCode]);
  return (
    <div className="grid md:grid-cols-2 gap-3">
      <Field label="Departamento" htmlFor={`${idPrefix}-dep`} hint={hint} required={required} error={errors?.department}>
        <SelectorBuscable id={`${idPrefix}-dep`} value={departmentCode} options={departments} placeholder="Elige el departamento" placeholderBusqueda="Departamento…" limpiable disabled={disabled} onChange={(v) => onChange({ departmentCode: v, municipalityCode: v && municipalityCode?.startsWith(v) ? municipalityCode : null })} />
      </Field>
      <Field label="Municipio" htmlFor={`${idPrefix}-mun`} required={required} error={errors?.municipality}>
        <SelectorBuscable id={`${idPrefix}-mun`} value={municipalityCode} options={municipalities} placeholder={departmentCode ? 'Elige el municipio' : 'Primero el departamento'} placeholderBusqueda="Municipio…" limpiable textoVacio="No hay municipios con ese nombre" disabled={disabled || !departmentCode} onChange={(v) => onChange({ departmentCode: departmentCode ?? (v ? v.slice(0, 2) : null), municipalityCode: v })} />
      </Field>
    </div>
  );
}
